import { AxiosInstance } from 'axios'
import { BaseApi } from '@/api/BaseApi'

export const PATH = {
  STORE_INPUT_RETAIN: '/api/common/input-retain/store',
  LOAD_INPUT_RETAIN: '/api/common/input-retain/load',
  DELETE_INPUT_RETAIN: '/api/common/input-retain/delete',
} as const

export type StoreInputRetainRequest<T extends Record<string, unknown>> = {
  key_name: string
  redirect_url: string
  store_key_name: string
} & T

export type LoadInputRetainRequest = {
  key_name: string
  is_force_get: boolean
}

export type LoadInputRetainApiResponse<T extends Record<string, unknown>> = {
  status: boolean
  message: string
  data: StoreInputRetainRequest<T>
}

export type DeleteInputRetainRequest = {
  key_name: string
}

export class InputRetainApi {
  baseApi: BaseApi
  constructor(axios: AxiosInstance) {
    this.baseApi = new BaseApi(axios)
  }

  /**
   * フォトグラファー入力内容保持
   * @param request
   */
  public async storeInputRetain<T extends Record<string, unknown>>(request: StoreInputRetainRequest<T>): Promise<void> {
    await this.baseApi.post(PATH.STORE_INPUT_RETAIN, request)
  }

  /**
   * フォトグラファー入力内容取得
   * @param request
   */
  public async loadInputRetain<T extends Record<string, unknown>>(
    request: LoadInputRetainRequest
  ): Promise<LoadInputRetainApiResponse<T>['data']> {
    const { data } = await this.baseApi.post<typeof request, LoadInputRetainApiResponse<T>>(
      PATH.LOAD_INPUT_RETAIN,
      request
    )
    return data.data
  }

  /**
   * フォトグラファー入力内容削除
   * @param request
   */
  public async deleteInputRetain(request: DeleteInputRetainRequest): Promise<void> {
    await this.baseApi.post(PATH.DELETE_INPUT_RETAIN, request)
  }
}
